// Coveo Result List click and render CRL
analytics.eventConfig.push({
    "target": ".CoveoResultList",
    "codeId": "crl",
    "events": [
        {
            "eventTarget": ".CoveoResultLink",
            "eventType": "click",
            "tags": {
                "componentId": "crl",
                "componentName": "coveo results list",
                "destinationUrl": "",
                "elementText": "",
                "elementType": "search results list",
                "event": "onsite search",
                "eventType": "search results click through",
                "resultType": "",
                "searchFacets": "",
                "searchResults": "",
                "searchTerm": "",
                "searchType": "",
                "showMore": "",
                "doc_path": "",
                "document_host": "",
                "event1": "",
                "page_type": "",
                "page_bu": "",
                "page_language": "",
                "page_title": "",
                "pardot_cookie_id": "",
                "site_search_results_count": 0,
                "sitecore_contact_id": "",
                "eventAction": "",
                "eventCategory": "",
                "eventLabel": "",
                "environment": "",
            }
        },
        {
            "eventTarget": ".coveo-result-list-container",
            "eventType": "SearchResultsRendering",
            "tags": {
                "componentId": "crl",
                "componentName": "coveo results list",
                "elementType": "search results list",
                "event": "onsite search",
                "eventType": "search results return",
                "searchFacets": "",
                "searchResults": "",
                "searchTerm": "",
                "searchType": "",
                "showMore": "",
                "doc_path": "",
                "document_host": "",
                "event1": "",
                "page_type": "",
                "page_bu": "",
                "page_language": "",
                "page_title": "",
                "pardot_cookie_id": "",
                "site_search_results_count": 0,
                "sitecore_contact_id": "",
                "eventAction": "",
                "eventCategory": "",
                "eventLabel": "",
                "environment": "",

            }
        }
    ]
},
    {
        "target": ".CoveoResultList",
        "codeId": "crl",
        "events": [
            {
                "eventTarget": ".CoveoResult a:not(.CoveoResultLink)",
                "eventType": "click",
                "tags": {
                    "componentId": "crl",
                    "componentName": "coveo results list",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "search results list",
                    "event": "onsite search",
                    "eventType": "search results click through",
                    "resultType": "",
                    "searchFacets": "",
                    "searchResults": "",
                    "searchTerm": "",
                    "searchType": "",
                    "showMore": "",
                    'event1': '',
                    'eventCategory': '',
                    'eventAction': 'Document Downloaded',
                    'eventLabel': "",
                    "environment": "",
                    'document_title': "",
                    'document_type': "",
                    'page_type': "",
                    'page_title': "",
                    'page_bu': "",
                    'page_language': "",
                    'sitecore_contact_id': "",
                    'pardot_cookie_id': ""

                }
            }
        ]
    },
    {// Coveo Search Box CSB
        "target": ".CoveoSearchInterface",
        "events": [
            {
                "eventTarget": ".recent-searches a",
                "eventType": "click",
                "tags": {
                    "event": "onsite search",
                    "componentName": "coveo search box",
                    "componentId": "csb",
                    "eventType": "search submit",
                    "elementType": "recent search link",
                    "parentName": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": ".magic-box-suggestions",
                "eventType": "SearchBoxSuggestion",
                "tags": {
                    "componentId": "csb",
                    "componentName": "coveo search box",
                    "event": "onsite search",
                    "eventType": "search submit",
                    "elementType": "auto-suggestion",
                    "parentName": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": ".CoveoSearchbox",
                "eventType": "SearchBoxSearch",
                "tags": {
                    "componentId": "csb",
                    "componentName": "coveo search box",
                    "event": "onsite search",
                    "eventType": "search submit",
                    "elementType": "search box",
                    "parentName": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": "a.CoveoSearchButton",
                "eventType": "click",
                "tags": {
                    "componentId": "csb",
                    "componentName": "coveo search box",
                    "event": "onsite search",
                    "eventType": "search submit",
                    "elementType": "search box",
                    "parentName": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            }
        ]
    },
    { // Coveo Facet CF
        "target": ".component.coveo-facet",
        "codeId": "cf",
        "events": [
            {
                "eventTarget": ".CoveoFacet",
                "eventType": "FacetChanged",
                "tags": {
                    "event": "onsite search",
                    "eventType": "",
                    "componentName": "coveo facet",
                    "componentId": "cf",
                    "elementType": "search filter selection box",
                    "elementText": "",
                    "refinementCategory": "",
                    "searchTerm": "",
                    "searchType": ""
                }
            }
        ]
    },
    {
        "target": ".facet-modal",
        "codeId": "cf",
        "events": [
            {
                "eventTarget": "label",
                "eventType": "click",
                "tags": {
                    "componentId": "cf",
                    "componentName": "coveo facet",
                    "elementText": "",
                    "elementType": [
                        {
                            "rule": "$(context).parents('.modal').length > 0 || $(context).parents('.modal').attr('id') === 'location-modal'",
                            "value": "location link"
                        },
                        {
                            "rule": "true",
                            "value": "product family link"
                        }
                    ],
                    "event": "onsite search",
                    "eventType": [
                        {
                            "rule": "$(context).parents('.modal').length > 0 || $(context).parents('.modal').attr('id') === 'location-modal'",
                            "value": "location selection click"
                        },
                        {
                            "rule": "true",
                            "value": "product family selection click"
                        }
                    ],
                    "searchTerm": "",
                    "searchType": ""
                }
            }
        ]
    }, {
    "target": ".coveo-facet",
    "codeId": "cf",
    "events": [
        {
            "eventTarget": ".showLessText",
            "eventType": "click",
            "tags": {
                "componentId": "cf",
                "componentName": "coveo facet",
                "elementText": "show less",
                "elementType": "show less button",
                "event": "onsite search",
                "eventType": "show less facet click",
                "searchTerm": "",
                "searchType": "",
            }
        },
    ]
},
    {
        "target": ".coveo-facet",
        "codeId": "cf",
        "events": [
            {
                "eventTarget": ".showMoreText",
                "eventType": "click",
                "tags": {
                    "componentId": "cf",
                    "componentName": "coveo facet",
                    "elementText": "show more",
                    "elementType": "show more button",
                    "event": "onsite search",
                    "eventType": "show more facet click",
                    "searchTerm": "",
                    "searchType": "",
                }
            },
        ]
    },
    {   // Coveo Show More CRL
        "target": ".CoveoSearchInterface",
        "codeId": "crl",
        "events": [
            {
                "eventTarget": ".showMoreResults a",
                "eventType": "click",
                "tags": {
                    "componentId": "crl",
                    "componentName": "coveo results list",
                    "elementText": "",
                    "elementType": "load more button",
                    "event": "onsite search",
                    "eventType": "load more results click",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": ".coveo-pager-next span.coveo-pager-next-icon",
                "eventType": "click",
                "tags": {
                    "componentId": "crl",
                    "componentName": "coveo results list",
                    "elementText": "",
                    "elementType": "load next button",
                    "event": "onsite search",
                    "eventType": "load next page results click",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": ".coveo-pager-previous span.coveo-pager-previous-icon",
                "eventType": "click",
                "tags": {
                    "componentId": "crl",
                    "componentName": "coveo results list",
                    "elementText": "",
                    "elementType": "load previous button",
                    "event": "onsite search",
                    "eventType": "load previous page results click",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": "a.seeallList",
                "eventType": "click",
                "tags": {
                    "componentId": "crl",
                    "componentName": "coveo results list",
                    "elementText": "",
                    "elementType": "load all button",
                    "event": "onsite search",
                    "eventType": "load all results click",
                    "searchTerm": "",
                    "searchType": ""
                }
            },
            {
                "eventTarget": "a.seeLessList",
                "eventType": "click",
                "tags": {
                    "componentId": "crl",
                    "componentName": "coveo results list",
                    "elementText": "",
                    "elementType": "load less button",
                    "event": "onsite search",
                    "eventType": "load less results click",
                    "searchTerm": "",
                    "searchType": ""
                }
            }
        ]
    });

// Custom Analytics for Library Search Page
class SearchAnalytics {
    constructor() {
        this.searchAnalyticsConfiguration = searchAnalyticsConfiguration;
    }

    init() {
        const root = Coveo.$$(document).find('.coveo-searchinterface .CoveoSearchInterface');
        Coveo.$$(root).on("newResultsDisplayed", () => {
            this.triggerAnalytics();
        });
    }

    triggerAnalytics() {
        const datalayerItem = {
            event1: "global search",
            componentName: "coveo results list",
            searchTerm: this.getSearchTerm(),
            searchType: this.searchAnalyticsConfiguration.searchType,
            resultsCount: this.getResultsCount(),
            deviceType: this.getDeviceType()
        };

        // Directly use facetConfig 
        this.getFacetValues(datalayerItem, this.searchAnalyticsConfiguration.facetConfig);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push(datalayerItem);
    }

    getFacetValues(tagsObject, facetConfigArray) {
        if (!Array.isArray(facetConfigArray) || facetConfigArray.length === 0) {
            return;
        }

        facetConfigArray.forEach(({ dataField, facet }) => {
            tagsObject[facet] = '';

            const facetContainer = document.querySelector(`[data-field="${dataField}"]`);
            if (facetContainer) {
                const checkedFacetCheckboxes = facetContainer.querySelectorAll('input[type="checkbox"]:checked');

                const selectedFacetValues = Array.from(checkedFacetCheckboxes)
                    .map(checkbox => checkbox.closest('li')?.querySelector('.coveo-facet-value-caption')?.textContent.trim())
                    .filter(Boolean)
                    .join(', ');

                tagsObject[facet] = selectedFacetValues;
            }
        });
    }

    getSearchTerm() {
        const highlightElement = document.querySelector('.coveo-highlight');
        if (!highlightElement) return '';

        if (highlightElement.classList.contains('coveo-highlight-first')) {
            const queryElement = document.querySelector('.coveo-highlight-query');
            return queryElement ? queryElement.textContent.trim() : '';
        }

        return highlightElement.textContent.trim();
    }


    getResultsCount() {
        const getText = (selector) => {
            const element = document.querySelector(selector);
            return element?.textContent.trim() || '';
        };
        const firstResult = getText('.coveo-highlight-first');
        const lastResult = getText('.coveo-highlight-last');
        const totalResults = getText('.coveo-highlight-total-count');

        const range = lastResult ? `${firstResult}-${lastResult}` : firstResult;
        return (!range || !totalResults)
        ? 'Showing 0 of 0 results'
        : `Showing ${range} of ${totalResults} results`;

    }

    getDeviceType() {
        const userAgent = navigator.userAgent;
        const width = window.innerWidth;

        if (/Tablet|iPad/i.test(userAgent) || (width > 768 && width <= 1024)) {
            return "tablet";
        } else if (/Mobile|Windows Phone|Lumia|Android|webOS|iPhone|Blackberry|PlayBook|BB10|Opera Mini|\bCrMo\/|Opera Mobi/i.test(userAgent)) {
            return "mobile";
        } else {
            return "desktop";
        }
    }
}

const config = window.searchAnalyticsConfiguration;
if (config) {
    const searchAnalytics = new SearchAnalytics();
    searchAnalytics.init();
}
